import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Device } from '../../../../model/device';
import { FormGroup } from '@angular/forms';
import { ActionButton } from '../../../../model/ui/action-button';

@Component({
  selector: 'app-synoptics-form-event-data',
  templateUrl: './synoptics-form-event-data.component.html',
  styleUrls: ['./synoptics-form-event-data.component.scss']
})
export class SynopticsFormEventDataComponent implements OnInit {

  @Input() synopticInfoForm: FormGroup;
  @Output() devicesChange: EventEmitter<Device[]>;

  public devicesFirst: number;
  public devicesRows: number;
  public displayDevicesSelector: boolean;
  public selectDevicesActions: ActionButton[];
  public currentDevices: Device[];

  constructor() {
    this.devicesChange = new EventEmitter<Device[]>();
    this.displayDevicesSelector = false;
    this.devicesFirst = 0;
    this.devicesRows = 10;
    this.selectDevicesActions = [
      { label: 'select.devices', icon: 'pi pi-check', action: (devices: Device[]) => this.selectDevices(devices) }
    ];
  }

  @Input()
  set devices(devices: Device[]) {
    this.currentDevices = devices ? [...devices] : [];
  }

  ngOnInit(): void {
  }

  private selectDevices(devices: Device[]): void {
    this.displayDevicesSelector = false;
    this.currentDevices = devices;
    this.devicesChange.emit([...this.currentDevices]);
  }

  public removeDevice(device: Device): void {
    const index = this.currentDevices.indexOf(device);
    this.currentDevices.splice(index, 1);
    this.devicesChange.emit([...this.currentDevices]);
  }

}
